import { useUpdateSchoolUserEmailSettingsMutation } from 'api/users.api';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { SchoolUserEmailSettings, User } from 'models/User';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import CommunicationSettings from 'router/subrouters/Dashboard/components/CommunicationSettings';
import authSelectors from 'store/selectors/auth.selectors';
import { updateUser } from 'store/slices/auth.slice';
import {
  popServerError,
  popSuccess,
} from 'store/slices/popNotifications.slice';
import useSchoolCommunicationSettings from '../../hooks/useSchoolCommunicationSettings';

import './SchoolCommunicationSettings.styles.scss';

const SchoolCommunicationSettings: React.FC = () => {
  const schoolCommunicationList = useSchoolCommunicationSettings();

  const user = useAppSelector(authSelectors.selectUser);

  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const [updateSchoolUserEmailSettings] =
    useUpdateSchoolUserEmailSettingsMutation();

  const handleSubmit = useCallback(
    async (values: SchoolUserEmailSettings) => {
      updateSchoolUserEmailSettings(values)
        .unwrap()
        .then(({ communicationPreference }) => {
          dispatch(updateUser({ communicationPreference } as User));
          dispatch(popSuccess(t('communicationSettingsUpdatedSuccess')));
        })
        .catch((e) => dispatch(popServerError(e)));
    },
    [dispatch, t, updateSchoolUserEmailSettings],
  );

  return (
    <CommunicationSettings
      communicationList={schoolCommunicationList}
      handleSubmit={handleSubmit}
      initialValues={user?.communicationPreference}
      className="school-communication-settings"
    />
  );
};

export default SchoolCommunicationSettings;
